import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Router} from '@angular/router';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';

@Injectable({
  providedIn: 'root'
})

export class CreateTreatyOtherDocumentContentToolLinkHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  commandEmitter: EventEmitter<any>;

  constructor(
    private router: Router
  ) {
    this.commandEmitter = new EventEmitter<any>();
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    } else {
      switch (command.name) {
        default:
          this.commandEmitter.emit(command);
          break;
      }
    }
  }
  setSelectedTab(selectedTab: TabModel): void {
    if (selectedTab?.tabData?.DocumentId) {
      this.showSelectedMenuItemInTop(selectedTab.tabData.DocumentId);
    }
  }
  showSelectedMenuItemInTop(documentId: string, count: number = 0) {
    if (count === 5) {
      return;
    }
    const element = document.getElementById(documentId);
    if (element) {
      element.scrollIntoView(true);
      return true;
    } else {
      setTimeout(() => {
        this.showSelectedMenuItemInTop(documentId, count + 1);
      }, 1000);
    }
  }

  valueChanged($event) {
  }

}
